/**
 * External Dependencies
 */
import 'jquery';

$(() => {
  var $map = $('#map');
  if ($map.length) {
    var data = Highcharts.geojson(Highcharts.maps['countries/us/us-all']),
      $map_toggle = $('#content').find('.map-toggle'),
      $leg = $('#content').find('.legislative');

    $map_toggle.on('click', 'li', function (e) {
      var target = $(this).find('a').attr('href');
      e.preventDefault();
      $leg.hide();
      $(target).show();
      $map_toggle.find('li').hide();
      if ($(this).hasClass('map')) {
        $map_toggle.find('li.list').css({ display: 'block' });
      } else {
        $map_toggle.find('li.map').css({ display: 'block' });
      }
    });

    $map.highcharts('Map', {
      plotOptions: {
        series: {
          color: '#dd4600',
          borderColor: '#ffffff',
          enableMouseTracking: true,
          states: {
            hover: {
              brightness: 0.1,
            },
          },
        },
      },
      chart: {
        animation: false,
        margin: 0,
        backgroundColor: '#f5f5f3',
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '',
        style: {
          display: 'none',
        },
      },
      subtitle: {
        text: '',
        style: {
          display: 'none',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function () {
          var hoverState = mapdata.find(({ name }) => name === this.point.name);
          var string = this.point.name.toUpperCase();

          if (hoverState.status.includes('enacted')) {
            string += '<br>• Legal';
          }
          if (hoverState.status.includes('amendment-pending')) {
            string += '<br>• Amendment Pending';
          }
          if (hoverState.status.includes('under-threat')) {
            string += '<br>• Under Threat';
          }
          if (hoverState.status.includes('pending-bill')) {
            string += '<br>• Considering DWD';
          }
          if (hoverState.status.includes('no-legislation')) {
            string += '<br>• No Legislative Activity';
          }
          return string;
        },
        backgroundColor: '#282828',
        borderRadius: 2,
        borderColor: 'none',
        style: {
          color: '#fff',
          fontWeight: 'bold',
        },
      },
      series: [
        {
          nullColor: '#dd4600',
          joinBy: 'name',
          mapData: data,
          name: 'USA',
          cursor: 'pointer',
          point: {
            events: {
              click: function () {
                location.href = this.options.url;
              },
            },
          },
          dataLabels: {
            enabled: false,
          },
          data: mapdata,
        },
      ],
    });
  }
});
